import { render } from "./TaskDescriptionModal.vue?vue&type=template&id=7c88caaa"
import script from "./TaskDescriptionModal.vue?vue&type=script&lang=js"
export * from "./TaskDescriptionModal.vue?vue&type=script&lang=js"

import "./TaskDescriptionModal.vue?vue&type=style&index=0&id=7c88caaa&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__